import React from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import style from '../styles/best.module.scss'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { arrowRightIcon } from '@/images'
import SliderContainer from '@/components/Container/SliderContainer'
import PlayButton from '@/components/Button/PlayButton'
import { api } from '@/api'
import useSWR from 'swr'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

SwiperCore.use([Navigation])

const VideoSlider = ({ playVideo, setPlayVideo }): React.ReactElement => {
  const { data } = useSWR('/professions_video/', api.getProfessionsVideo)

  return (
    <SliderContainer>
      {data?.results?.length > 0
        ? (
          <div className={style.slider_buttons}>
            <button className='slider_button slider_button_prev js_best_prev'>
              <GxIcon src={arrowRightIcon} className={style.slider__icon} />
            </button>
            <button className='slider_button slider_button_next js_best_next'>
              <GxIcon src={arrowRightIcon} className={style.slider__icon} />
            </button>
          </div>
          )
        : null}

      <Swiper
        slidesPerView='auto'
        spaceBetween={20}
        resizeObserver
        navigation={{
          prevEl: '.js_best_prev',
          nextEl: '.js_best_next'
        }}
        freeMode
        grabCursor
      >
        {data === undefined
          ? (
            <>
              <SwiperSlide className={style.slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              <SwiperSlide className={style.slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
            </>
            )
          : (
              data.results.map((slide) => {
                return (
                  <SwiperSlide key={slide.id} className={style.slide}>
                    {playVideo === `video_slider_${String(slide.id)}`
                      ? (
                        <video
                          width='400px'
                          height='300px'
                          controls
                          controlsList='nodownload'
                          autoPlay
                          className={style.slide__video}
                        >
                          <source
                            src={slide.property_video_value?.[0] ?? ''}
                            type='video/mp4'
                          />
                        </video>
                        )
                      : (
                        <>
                          <img
                            src={slide.preview_picture?.[0] ?? ''}
                            width='560px'
                            height='311'
                            alt={slide.title}
                            className={style.slide__preview}
                          />
                          <div className={style.slide__button_positioner}>
                            <PlayButton
                              onClick={() => {
                                setPlayVideo(`video_slider_${String(slide.id)}`)
                              }}
                            />
                          </div>
                          <div title={slide.title} className={style.slide__content}>
                            <span className={style.slide__title}>{slide.name}</span>
                          </div>
                        </>
                        )}
                  </SwiperSlide>
                )
              })
            )}
      </Swiper>
    </SliderContainer>
  )
}

export default VideoSlider
